import React from 'react';
import PropTypes from 'prop-types';

import { getEncodedVariantId } from '../../Utils/VariantUtils';
import { StyledButton } from './DonateADollarStyles';

var DonateADollar = function DonateADollar(props) {
  var donateProduct = props.donateADollarProduct;

  var encodedVariantId = getEncodedVariantId(donateProduct.variants[0].id);

  var customAttributes = [{ key: '_vendor', value: donateProduct.vendor }];

  // Wrapper div because flex parent forces button height = 0 ¯\_(ツ)_/¯
  return React.createElement(
    'div',
    null,
    React.createElement(
      StyledButton,
      {
        onClick: function onClick() {
          return props.addVariantToCart([{
            variantId: encodedVariantId,
            quantity: 1,
            customAttributes: customAttributes
          }]);
        }
      },
      React.createElement(
        'span',
        null,
        props.donationBoxCopy
      )
    )
  );
};

DonateADollar.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  donateADollarProduct: PropTypes.object,
  donationBoxCopy: PropTypes.string
};

export default React.memo(DonateADollar);